import { statusFormProps } from "../shared/statusFormProps";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Drawer } from "../shared/Drawer";
import { DynamicForm } from "../dynamicForm";
import { usePermission } from "../shared/permissions";
import { trackEvent } from "../shared/Snowplow";
import { DynamicGrid } from "../dynamicGrid";
import {
  sharedProcessingByIdQueryOptions,
  sharedProcessingFormQueryOptions,
  updateSharedProcessingAnswersMutationOptions,
  updateSharedProcessingStatusMutationOptions,
} from "../api/sharedProcessings";
import { DescriptionStatusSelect } from "./DescriptionStatusSelect";
import { SharedProcessingDrawerHeader } from "./SharedProcessingDrawerHeader";
import { useTranslation } from "@privacy/translations";

export const SharedProcessingGuidedDrawer = () => {
  const sharedProcessingId = DynamicGrid.useSelectedRowId();
  const sharedProcessingQuery = useQuery(sharedProcessingByIdQueryOptions(sharedProcessingId));
  const formQuery = useQuery(sharedProcessingFormQueryOptions());
  const answersMutation = useMutation(updateSharedProcessingAnswersMutationOptions());
  const updateStatusMutation = useMutation(updateSharedProcessingStatusMutationOptions(sharedProcessingId));
  const { hasPermission } = usePermission();
  const { t } = useTranslation();

  return (
    <DynamicForm.MultiStepFormDialog>
      {(() => {
        if (!sharedProcessingQuery.data || !formQuery.data) return <Drawer.Loading />;

        const sharedProcessing = sharedProcessingQuery.data;
        return (
          <DynamicForm.Provider
            key={sharedProcessing.id}
            fileOwner={{ type: "Registration", id: sharedProcessing.id }}
            onSave={answer => {
              trackEvent.answerQuestionRegistrationGuidedView(answer.type);
              return answersMutation.mutateAsync({ id: sharedProcessing.id, answers: [answer] });
            }}
            answers={sharedProcessing.answers}
            isReadOnly={!hasPermission("nova-forms-api:enterprise-customers:registrations:manage")}
            isSaveError={answersMutation.isError}
            isSaving={answersMutation.isPending}
            {...statusFormProps(
              sharedProcessing,
              updateStatusMutation.error,
              t("RegistrationDrawer.UnansweredMandatoryQuestion.Input")
            )}
          >
            {({ formState }) => (
              <DynamicForm.Form
                header={
                  <SharedProcessingDrawerHeader
                    activeTab="guided"
                    sharedProcessing={sharedProcessing}
                    statusIndicator={DynamicForm.formStateToDrawerHeaderStatus(formState)}
                    topRightSlot={
                      <DescriptionStatusSelect
                        sharedProcessing={sharedProcessing}
                        updateStatusMutation={updateStatusMutation}
                      />
                    }
                  />
                }
                form={formQuery.data}
              />
            )}
          </DynamicForm.Provider>
        );
      })()}
    </DynamicForm.MultiStepFormDialog>
  );
};
